import { getBootSnapshot, recoverBoot } from '#~/routes/root/boot-budget.js';
import { isElectronApp } from '#~/electron/utils.js';
import { Centered } from '@studio/design-system/overlay';
import { Spinner } from '@studio/design-system/spinner';
import { vendorName } from '@studio/design-system/themes/vendor.js';
import { useTimer } from '@studio/react-utils/hooks';
import type { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';

/** `<Update>` component. */
export const Update = (): ReactElement => {
  const navigate = useNavigate();

  // Wait a few seconds for the the agent to be updated.  The launcher does not provide us with any useful feedback, so this is @fixme hack.
  useTimer(() => {
    if (isElectronApp()) {
      // electron app will handle the signalling to the browser window to reload itself
      return;
    }

    navigate('/');
    if (getBootSnapshot()) void recoverBoot('reload');
    else window.location.reload();
  }, 15e3);

  return (
    <Centered>
      <div className='flex items-center gap-8 text-xl'>
        <Spinner /> Updating {vendorName()} Bridge...
      </div>
    </Centered>
  );
};
